export default "__VITE_ASSET__DKjju4VO__"